<app-header [dir]="dir" />
<section
  class="consultation-area ptb-200"
  [dir]="currentLang === 'ar' ? 'rtl' : 'ltr'"
>
  <div class="container">
    <div class="contact-form">
      <h3>{{ "translations.contact_us" | translate }}</h3>
      <!-- Success Message -->
      <div class="alert alert-success" *ngIf="submitSuccess">
        {{ "translations.submission_success" | translate }}
      </div>

      <!-- Error Message -->
      <div class="alert alert-danger" *ngIf="submitError">
        {{ submitError }}
      </div>
      <form #consultationForm="ngForm"
            (ngSubmit)="submit(consultationForm.value)">
        <div class="row">
          <!-- Name Field -->
          <div class="col-lg-12 col-md-6">
            <div class="form-group mb-3">
              <div class="select-box">
                <label>{{ "translations.name" | translate }} <span>*</span></label>
                <input required
                       minlength="3"
                       maxlength="50"
                       ngModel
                       name="name"
                       type="text"
                       #name="ngModel"
                       class="form-control"
                       placeholder="{{ 'translations.name' | translate }}" />
              </div>
              <div class="alert alert-danger"
                   *ngIf="name.touched && !name.valid">
                <div *ngIf="name.errors?.['required']">
                  {{ "translations.Name_is_required" | translate }}
                </div>
                <div *ngIf="name.errors?.['minlength']">
                  {{
 "translations.Name_is_minimum" | translate
                  }}{{ name.errors?.['minlength'].requiredLength }}
                  character.
                </div>
                <div *ngIf="name.errors?.['maxlength']">
                  {{ "translations.Name_is_maximum_50_character" | translate }}
                </div>
              </div>
            </div>
          </div>

          <!-- Email Field -->
          <div class="col-lg-12 col-md-6">
            <div class="form-group mb-3">
              <div class="select-box">
                <label>{{ "translations.email" | translate }} <span>*</span></label>
                <input required
                       ngModel
                       name="email"
                       type="email"
                       #email="ngModel"
                       class="form-control"
                       placeholder="{{ 'translations.email' | translate }}" />
              </div>
              <div class="alert alert-danger"
                   *ngIf="email.touched && !email.valid">
                {{ "translations.Email_Address_is_required" | translate }}
              </div>
            </div>
          </div>

          <!-- Phone Number Field -->
          <div class="col-lg-12 col-md-12">
            <div class="form-group mb-3">
              <div class="select-box">
                <label>{{ "translations.phone" | translate }} <span>*</span></label>
                <input required
                       ngModel
                       name="number"
                       type="text"
                       #number="ngModel"
                       class="form-control"
                       placeholder="9123 6543" />
              </div>
              <div class="alert alert-danger"
                   *ngIf="number.touched && !number.valid">
                {{ "translations.Phone_number_is_required" | translate }}
              </div>
            </div>
          </div>

          <!-- Consultation Details -->
          <div class="col-lg-12 col-md-12">
            <div class="form-group mb-3">
              <div class="select-box">
                <label>
                  {{ "translations.contactDetails" | translate }}
                  <span>*</span>
                </label>
                <textarea required
                          ngModel
                          #message="ngModel"
                          name="message"
                          cols="30"
                          rows="6"
                          class="form-control"></textarea>
              </div>
              <div class="alert alert-danger"
                   *ngIf="message.touched && !message.valid">
                {{ "translations.Consultation_Details_Required" | translate }}
              </div>
            </div>
          </div>

          <!-- Submit Button -->
          <div class="col-lg-12 col-md-12">
            <button type="submit"
                    class="default-btn"
                    [class.disabled]="!consultationForm.valid">
              {{ "translations.Send_Contact" | translate }}
            </button>
          </div>
        </div>
      </form>
      <br />
      <br />

      <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3656.828758750032!2d58.408663911239586!3d23.574592895413836!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e91ff0013abedbb%3A0x8d8703738662d2e!2sMIW_OMAN!5e0!3m2!1sen!2som!4v1744779844877!5m2!1sen!2som" width="100%" height="450" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
    </div>
  </div>
</section>
<app-footer [dir]="dir" />
